import { Step } from '@/components/Step'

import { SurveyProgress } from './SurveyProgress'

export const IndicationSurvey = () => {
  return (
    <>
      <SurveyProgress />
      <Step />
    </>
  )
}
